module.exports = __webpack_public_path__ + "static/media/water-rise.8f0e75d1.svg";